import { render, staticRenderFns } from "./ForgotPasswordLink.vue?vue&type=template&id=05aa3c04&scoped=true"
import script from "./ForgotPasswordLink.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordLink.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&id=05aa3c04&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aa3c04",
  null
  
)

export default component.exports